import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const baseUrl = process.env.REACT_APP_SECONDARY_SERVER;

export const secondaryapi = createApi({
  reducerPath: 'articleapi',
  baseQuery: fetchBaseQuery({
    baseUrl,
    prepareHeaders: (headers, { endpoint }) => {
      const token = localStorage.getItem('AdminAccessToken');
      const noAuthEndpoints = ['submitLogin'];

      if (token && !noAuthEndpoints.includes(endpoint)) {
        headers.set('authorization', `Bearer ${token}`);
      }
      
      return headers;
    },
  }),
  tagTypes: ['AtozResources', 'ResourceTags', 'TestKitchen', 'TestKitchenTags', 'DietaryTags', 'OperationalTags', 'ServiceTags', 'SeasonalTags', 'AllKitchenTags', 'RecommendedPartners'],
  // tagTypes: ['Materials'], // Add tagTypes for cache management
  endpoints: (builder) => ({
    getAllmaterials: builder.query({
      query: () => `api/admin/list-business-materials`,
    }),
    getBusinessmaterialsubcategory: builder.query({
      query: (id) => `api/admin/list-subcategories/${id}/subcategories`,
    }),
    getBusinessmaterialtype: builder.query({
      query: ({ id, mid }) => `api/admin/business-material/${mid}/subcategory/${id}/material-types`,
    }), 
    getBusinessmaterialview: builder.query({
      query: ({ businessmaterial_id, subcategory_id, materialtype_id }) => `api/admin/business-material/${businessmaterial_id}/subcategories/${subcategory_id}/records/materialtype/${materialtype_id}`,
    }),    
    deleteBusinessmaterial: builder.mutation({
      query: ({ businessmaterial_id }) => ({
        url: `api/admin/records/${businessmaterial_id}`,
        method: 'DELETE',
      }),
    }),
    addBusinessmaterials: builder.mutation({
      query: (newPost) => ({
        url: 'api/admin/add-material-records',
        method: 'POST',
        body: newPost,
      }),
    }),
    getBusinessmaterialsofcs: builder.query({
      query: ({id}) => `api/admin/cafe-business-material/with-saved?directory_listing_id=${id}`,
    }), 
    getHuddleStatistics: builder.query({
      query: () => `api/admin/huddle-sessions-and-records/count`,
    }), 
    getMentorship: builder.query({
      query: () => `api/admin/get-huddle-sessions`,
    }), 
    gethuddlesessiondetails: builder.query({
      query: (id) => `api/admin/huddle-session/${id}`,
    }), 
    addHuddlesession: builder.mutation({
      query: (newPost) => ({
        url: 'api/admin/create-huddle-sessions',
        method: 'POST',
        body: newPost,
      }),
    }),
    getinvitedusers: builder.query({
      // query: (id) => `api/admin/invited-users?status=invited`,
      query: ({id,activeButton}) => `api/admin/invited-users/${id}?status=${activeButton}`,
    }),
    sendinvitation: builder.mutation({
      query: (newPost) => ({
        url: 'api/admin/send-invitations',
        method: 'POST',
        body: newPost, // Send newPost directly as the body
      }),
    }),
    getGroupsession: builder.query({
      query: () => `api/admin/list-session`,
    }), 
    gpamountedit: builder.mutation({
      query: (postData) => ({
        url: `api/admin/sessions/1/update-price`, 
        method: 'POST',  
        body:  postData ,  
      }),
    }),

    getAllMaterial: builder.query({
      query: ({userId, branchId}) => `api/cafe-business-materials/with-saved?user_id=${userId}&directory_listing_id=${branchId}`,  
    }),

    getBusinessMaterials: builder.query({
      query: () => `api/business-materials`,
    }),
    getSubCategorybyMaterialId: builder.query({
      query: ({id}) => `api/get-material-subcategory/${id}`,
    }),
    getAllRecordsbyMaterialId: builder.query({
      query: ({businessmaterialid, subcategory_id}) => `api/business-materials/${businessmaterialid}/subcategories/${subcategory_id}/records`,
    }),
    getMaterialType: builder.query({
      query: () => 'api/all-material-types'
    }),
    getMaterialTypebyCategoryId: builder.query({
      query: ({businessmaterialid, subcategory_id}) => `api/material-types/${businessmaterialid}/${subcategory_id}`
    }),
  
    getRecordsById: builder.query({
      query: ({businessmaterialid, subcategory_id,materialtypeid}) => `api/business-materials/${businessmaterialid}/subcategories/${subcategory_id}/records/material-type/${materialtypeid}`
    }),
  
    saveRecords:builder.mutation({
      query: (postData) => ({
        url: `api/user-record/save`,
        method: 'POST',
        body: postData,
      }),
    }),

    listSavedMaterialRecords: builder.query({
      query: ({userId,businessmaterialid, subcategory_id,directoryListingId,subcsriptionType,status}) => `api/list-records/${userId}/${businessmaterialid}/${subcategory_id}/${status}?directory_listing_id=${directoryListingId}`
    }),

    // listSavedMaterialRecords: builder.query({
    //   query: ({userId,businessmaterialid, subcategory_id,directoryListingId,subcsriptionType,status}) => `api/list-records/${userId}/${businessmaterialid}/${subcategory_id}/1?directory_listing_id=${directoryListingId}`
    // }),
    
    listUnSavedMaterialRecords: builder.mutation({
      query: ({ userId, record_id, directory_listing_id, subscription_type }) => ({
        url: `api/unsave-record/${userId}/${record_id}?directory_listing_id=${directory_listing_id}&subscription_type=${subscription_type}`,
        method: 'DELETE',
      }),
    }),

    saveImportInvite:builder.mutation({
      query: (postData) => ({
        url: `api/admin/invitations/import`,
        method: 'POST',
        body: postData,
      }),
    }),

    addBusinessMaterialCategoty :builder.mutation({
      query: (postData) => ({
        url: `api/admin/add-business-materials`,
        method: 'POST',
        body: postData,
      }),
    }),
    addBusinessMaterialSubCategoty :builder.mutation({
      query: (postData) => ({
        url: `api/admin/add-materials-subcategory`,
        method: 'POST',
        body: postData,
      }),
    }),
    addBusinessMaterialTYpe:builder.mutation({
      query: (postData) => ({
        url: `api/admin/add-material-types`,
        method: 'POST',
        body: postData,
      }),
    }),
    uploadBusinessMaterial:builder.mutation({
      query: (postData) => ({
        url: `api/admin/add-material-records`,
        method: 'POST',
        body: postData,
      }),
    }),

    getMatrialTYpeAdmin: builder.query({
      query: () => `api/admin/list-material-types`
    }),
    RemoveInvitationbyId:builder.mutation({
      query: (id) => ({
        url: `api/admin/invitations/${id}`,
        method: 'DELETE',
      }),
    }),
    deleteUserbyRecordId: builder.mutation({
      query: (user_id) => ({
        url: `api/delete-saved-records-invitations/${user_id}`,
        method: 'DELETE',
      }),
    }),

    // A-to-Z Resources
    getAtozResources: builder.query({
      query: () => 'api/admin/atoz-resources',
      providesTags: ['AtozResources'],
    }),

    // Dietary Tags Endpoints
  searchDietaryTags: builder.query({
    query: ({ query = '' }) => `api/admin/dietary-tags?query=${encodeURIComponent(query)}`,
    transformResponse: (response) => Array.isArray(response?.data) ? response.data : [],
    providesTags: (result = []) => [
      'DietaryTags',
      ...result.map(({ id }) => ({ type: 'DietaryTag', id }))
    ]
  }),
  
  createDietaryTag: builder.mutation({
    query: (tagData) => ({
      url: 'api/admin/dietary-tags',
      method: 'POST',
      body: tagData,
    }),
    invalidatesTags: ['DietaryTags']
  }),
  
  // Operational Tags Endpoints
  searchOperationalTags: builder.query({
    query: ({ query = '' }) => `api/admin/operational-tags?query=${encodeURIComponent(query)}`,
    transformResponse: (response) => Array.isArray(response?.data) ? response.data : [],
    providesTags: (result = []) => [
      'OperationalTags',
      ...result.map(({ id }) => ({ type: 'OperationalTag', id }))
    ]
  }),
  
  createOperationalTag: builder.mutation({
    query: (tagData) => ({
      url: 'api/admin/operational-tags',
      method: 'POST',
      body: tagData,
    }),
    invalidatesTags: ['OperationalTags']
  }),
  
  // Service Tags Endpoints
  searchServiceTags: builder.query({
    query: ({ query = '' }) => `api/admin/service-tags?query=${encodeURIComponent(query)}`,
    transformResponse: (response) => Array.isArray(response?.data) ? response.data : [],
    providesTags: (result = []) => [
      'ServiceTags',
      ...result.map(({ id }) => ({ type: 'ServiceTag', id }))
    ]
  }),
  
  createServiceTag: builder.mutation({
    query: (tagData) => ({
      url: 'api/admin/service-tags',
      method: 'POST',
      body: tagData,
    }),
    invalidatesTags: ['ServiceTags']
  }),
  
  // Seasonal Tags Endpoints
  searchSeasonalTags: builder.query({
    query: ({ query = '' }) => `api/admin/seasonal-tags?query=${encodeURIComponent(query)}`,
    transformResponse: (response) => Array.isArray(response?.data) ? response.data : [],
    providesTags: (result = []) => [
      'SeasonalTags',
      ...result.map(({ id }) => ({ type: 'SeasonalTag', id }))
    ]
  }),
  
  createSeasonalTag: builder.mutation({
    query: (tagData) => ({
      url: 'api/admin/seasonal-tags',
      method: 'POST',
      body: tagData,
    }),
    invalidatesTags: ['SeasonalTags']
  }),
  
  // Test Kitchen Endpoints
    getTestKitchenItems: builder.query({
      query: () => 'api/admin/test-kitchen',
      providesTags: ['TestKitchen'],
    }),
    
    getTestKitchenItem: builder.query({
      query: (id) => `api/admin/test-kitchen/${id}`,
      providesTags: (result, error, id) => [{ type: 'TestKitchen', id }],
    }),
    
    addTestKitchenItem: builder.mutation({
      query: (data) => {
        // If data is FormData, we need to let the browser set the Content-Type header
        // with the correct boundary for multipart/form-data
        const isFormData = data instanceof FormData;
        
        return {
          url: 'api/admin/test-kitchen',
          method: 'POST',
          body: data,
          // Don't set Content-Type header for FormData - let the browser set it with the correct boundary
          headers: isFormData ? {} : { 'Content-Type': 'application/json' }
        };
      },
      // Force refetch of all test kitchen items after a successful mutation
      invalidatesTags: ['TestKitchen'],
    }),
    
    updateTestKitchenItem: builder.mutation({
      query: ({ id, data }) => {
        const isFormData = data instanceof FormData;
        
        if (isFormData) {
          // For file uploads, use POST with _method=PUT for Laravel
          data.append('_method', 'PUT');
          return {
            url: `api/admin/test-kitchen/${id}`,
            method: 'POST',
            body: data,
            // Don't set Content-Type header for FormData - let the browser set it with the correct boundary
            headers: {}
          };
        }
        
        // For regular JSON data
        return {
          url: `api/admin/test-kitchen/${id}`,
          method: 'PUT',
          body: data,
          headers: { 'Content-Type': 'application/json' }
        };
      },
      invalidatesTags: (result, error, { id }) => [
        'TestKitchen',
        { type: 'TestKitchen', id },
      ],
    }),
    
    deleteTestKitchenItem: builder.mutation({
      query: (id) => ({
        url: `api/admin/test-kitchen/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['TestKitchen'],
    }),
    
    toggleTestKitchenItemStatus: builder.mutation({
      query: ({ id, status }) => ({
        url: `api/admin/test-kitchen/${id}/status`,
        method: 'PATCH',
        body: { status },
      }),
      invalidatesTags: (result, error, { id }) => [
        'TestKitchen',
        { type: 'TestKitchen', id },
      ],
    }),
    // Recommended Partners Endpoints (Admin)
    getRecommendedPartnersAdmin: builder.query({
      query: () => 'api/admin/recommended-partners',
      transformResponse: (response) => (Array.isArray(response?.data) ? response.data : []),
      providesTags: ['RecommendedPartners'],
    }),
    addRecommendedPartner: builder.mutation({
      query: (formData) => ({
        url: 'api/admin/recommended-partners',
        method: 'POST',
        body: formData,
      }),
      invalidatesTags: ['RecommendedPartners'],
    }),
    updateRecommendedPartner: builder.mutation({
      query: ({ id, formData }) => {
        // Laravel needs POST with _method=PUT for multipart updates
        formData.append('_method', 'PUT');
        return {
          url: `api/admin/recommended-partners/${id}`,
          method: 'POST',
          body: formData,
        };
      },
      invalidatesTags: ['RecommendedPartners'],
    }),
    deleteRecommendedPartner: builder.mutation({
      query: (id) => ({
        url: `api/admin/recommended-partners/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['RecommendedPartners'],
    }),
    toggleRecommendedPartnerStatus: builder.mutation({
      query: (id) => ({
        url: `api/admin/recommended-partners/${id}/status`,
        method: 'PATCH',
      }),
      invalidatesTags: ['RecommendedPartners'],
    }),
    addAtozResource: builder.mutation({
      query: (data) => ({
        url: 'api/admin/atoz-resources',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['AtozResources']
    }),
    getAtozResource: builder.query({
      query: (id) => `api/admin/atoz-resources/${id}`,
      providesTags: (result, error, id) => [{ type: 'AtozResource', id }]
    }),
    updateAtozResource: builder.mutation({
      query: ({ id, data }) => {
        // If data is FormData, we don't need to do anything special as it will set the headers correctly
        const body = data;
        
        return {
          url: `api/admin/atoz-resources/${id}`,
          method: 'POST', // We'll use POST with _method=PUT for Laravel
          body,
        };
      },
      invalidatesTags: (result, error, { id }) => [
        'AtozResources',
        { type: 'AtozResource', id }
      ]
    }),
    deleteAtozResource: builder.mutation({
      query: (id) => ({
        url: `api/admin/atoz-resources/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['AtozResources']
    }),
    
    // Resource Tags Endpoints (Admin)
    searchResourceTags: builder.query({
      query: (query) => `api/admin/resource-tags/search?query=${encodeURIComponent(query)}`,
      transformResponse: (response) => {
        // Handle nested data structure: response.data contains the array of tags
        // If response.data is an array, return it, otherwise return empty array
        return Array.isArray(response?.data) ? response.data : [];
      },
      providesTags: (result = []) => [
        'ResourceTags',
        ...result.map(({ id }) => ({ type: 'ResourceTag', id }))
      ]
    }),
    getResourceTags: builder.query({
      query: () => 'api/admin/resource-tags',
      transformResponse: (response) => {
        // Handle nested data structure: response.data contains the array of tags
        return Array.isArray(response?.data) ? response.data : [];
      },
      providesTags: (result = []) => [
        'ResourceTags',
        ...result.map(({ id }) => ({ type: 'ResourceTag', id }))
      ]
    }),
    createResourceTag: builder.mutation({
      query: (tagData) => ({
        url: 'api/admin/resource-tags',
        method: 'POST',
        body: tagData,
      }),
      invalidatesTags: ['ResourceTags']
    }),
    updateResourceTag: builder.mutation({
      query: ({ id, ...tagData }) => ({
        url: `api/admin/resource-tags/${id}`,
        method: 'PUT',
        body: tagData,
      }),
      invalidatesTags: (result, error, { id }) => [
        'ResourceTags',
        { type: 'ResourceTag', id }
      ]
    }),
    deleteResourceTag: builder.mutation({
      query: (id) => ({
        url: `api/admin/resource-tags/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['ResourceTags']
    }),
    
    // Get all test kitchen tags
    getAllTestKitchenTags: builder.query({
      query: () => 'api/admin/test-kitchen/tags/all',
      providesTags: ['AllKitchenTags']
    }),
  }),
});

export const { 
  useSearchResourceTagsQuery,
  useGetResourceTagsQuery,
  useGetAllTestKitchenTagsQuery,
  useCreateResourceTagMutation,
  useUpdateResourceTagMutation,
  useDeleteResourceTagMutation,
  useGetAllmaterialsQuery, useGetBusinessmaterialsubcategoryQuery,
  useGetBusinessmaterialtypeQuery, useGetBusinessmaterialviewQuery,
  useDeleteBusinessmaterialMutation, useAddBusinessmaterialsMutation,
  useGetAtozResourcesQuery, useGetAtozResourceQuery, useAddAtozResourceMutation,
  useUpdateAtozResourceMutation, useDeleteAtozResourceMutation,
  useGetBusinessmaterialsofcsQuery, useGetHuddleStatisticsQuery,
  useGetMentorshipQuery,useGethuddlesessiondetailsQuery, 
  useAddHuddlesessionMutation,useGetinvitedusersQuery,
  useSendinvitationMutation,useGetGroupsessionQuery,
  useGpamounteditMutation,
  useGetSubCategorybyMaterialIdQuery,
  useListUnSavedMaterialRecordsMutation,
  useListSavedMaterialRecordsQuery,useSaveImportInviteMutation,
  useAddBusinessMaterialCategotyMutation,
  useAddBusinessMaterialSubCategotyMutation,
  useAddBusinessMaterialTYpeMutation,
  useGetBusinessMaterialsQuery,
  useUploadBusinessMaterialMutation,
  useGetMatrialTYpeAdminQuery,
  useRemoveInvitationbyIdMutation,
  useDeleteUserbyRecordIdMutation,
  
  // Test Kitchen hooks
  useGetTestKitchenItemsQuery,
  useGetTestKitchenItemQuery,
  useAddTestKitchenItemMutation,
  useUpdateTestKitchenItemMutation,
  useDeleteTestKitchenItemMutation,
  useToggleTestKitchenItemStatusMutation,

  // Recommended Partners hooks
  useGetRecommendedPartnersAdminQuery,
  useAddRecommendedPartnerMutation,
  useUpdateRecommendedPartnerMutation,
  useDeleteRecommendedPartnerMutation,
  useToggleRecommendedPartnerStatusMutation,
  
  // Dietary Tags
  useSearchDietaryTagsQuery,
  useCreateDietaryTagMutation,
  
  // Operational Tags
  useSearchOperationalTagsQuery,
  useCreateOperationalTagMutation,
  
  // Service Tags
  useSearchServiceTagsQuery,
  useCreateServiceTagMutation,
  
  // Seasonal Tags
  useSearchSeasonalTagsQuery,
  useCreateSeasonalTagMutation
} = secondaryapi;
